import React from "react";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";

const Logout = () => {
  const { oktaAuth } = useOktaAuth();

  const logout = async () => {
    await oktaAuth.signOut("/");
  };

  return (
    <MenuItem onClick={logout}>
      <ListItemIcon>
        <ExitToAppIcon />
      </ListItemIcon>
      <ListItemText primary="Sign out" />
    </MenuItem>
  );
};

export default Logout;
